import { styled } from '@mui/material/styles';
import Tooltip from '@mui/material/Tooltip';
import { Box } from '@mui/system';
import { StatusIndicator } from '@openx/components-core/lib/StatusIndicator/StatusIndicator.tsx';
import { oaDealStatus } from '@openx/types/deal.ts';
import { forwardRef, type JSX, type ReactNode } from 'react';
import { useTranslation } from 'react-i18next';

import { mapStatus } from '../../utils/mapStatus.ts';

interface StatusCellProps {
  status: string;
}

const StyledDiv = styled('div')({ alignItems: 'center', display: 'flex' });

const TooltipContent = forwardRef((props: { children: ReactNode }, ref) => (
  <Box ref={ref} {...props}>
    {props.children}
  </Box>
));

export function StatusCell({ status }: StatusCellProps): JSX.Element {
  const isDealProcessing = status === oaDealStatus.PUBLISHING || status === oaDealStatus.READY_FOR_ACTIVATION;

  const { t } = useTranslation();
  const statusData = mapStatus(t, status);

  return (
    <StyledDiv>
      <Tooltip
        data-test="tooltip-icon"
        title={
          isDealProcessing ? (
            <>
              {t("Deal can't be edited as it has")}
              <br />
              {t('not been activated yet.')}
            </>
          ) : (
            ''
          )
        }
      >
        <TooltipContent>
          <StatusIndicator {...statusData} data-test="status" />
        </TooltipContent>
      </Tooltip>
    </StyledDiv>
  );
}
